/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import _ from "lodash";

import FieldTextBox from "../../../shared/controls/fieldTextBox";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";

import imagenesUnidades from "./imagenesUnidades";
import constantes from "../../constantes";

import "./inspeccionLlanta.css";

/*
 * Orden visual de las llantas.
 */
const orden = [
  0, 1, 2, 3, 5, 4, 6, 7, 9, 8, 10, 11, 13, 12, 14, 15, 17, 16, 18, 19, 20, 21,
  22,
];

const InspeccionLlanta = ({ entity, actualizar, errors, editable }) => {
  const [imagenUnidad, setImagenUnidad] = useState({});

  const [imagenCaja, setImagenCaja] = useState({});

  useEffect(() => {
    const imagenUnidadEncontrada = imagenesUnidades.llantas.find(
      (llanta) =>
        llanta.esUnidad && llanta.tipoUnidadId === entity?.unidad?.tipoUnidadId,
    );

    setImagenUnidad(imagenUnidadEncontrada ?? imagenesUnidades.llantas[0]);

    const imagenCajaEncontrada = imagenesUnidades.llantas.find(
      (llanta) =>
        !llanta.esUnidad &&
        llanta.tipoUnidadId ===
          (entity?.esExterno ? 1 : entity?.caja?.tipoUnidadId),
    );

    setImagenCaja(imagenCajaEncontrada);
  }, [entity?.unidad, entity?.caja, entity?.nombreUnidad, entity?.esExterno]);

  function actualizarLlanta(value, index, propertyName, field) {
    let cambios;

    if (field === "estadoCautin") {
      cambios = {
        revisarCautin: value === true,

        sinCautinSeleccionado: value === false,

        ...(value === false
          ? {
              idCautin: "",
            }
          : {}),
      };
    } else if (field === "estadoLlantaDanada") {
      cambios = {
        llantaDanada: value === true,

        /*
         * Si desmarca el daño,
         * se limpia el tipo de daño.
         */
        ...(value === false
          ? {
              tipoLlantaDanada: null,
            }
          : {}),
      };
    } else {
      let property = field;

      /*
       * Cuando no se proporciona el
       * nombre del campo, se determina
       * por el tipo del valor.
       */
      if (!property) {
        property =
          value && typeof value === "object" && value.id !== undefined
            ? "marcaLlanta"
            : "idCautin";
      }

      cambios = {
        [property]: value,
      };
    }

    const lista = entity?.[propertyName];

    if (!Array.isArray(lista)) {
      return;
    }

    const listaActualizada = lista.map((elemento, currentIndex) =>
      currentIndex !== index
        ? elemento
        : {
            ...elemento,
            ...cambios,
          },
    );

    actualizar(listaActualizada, propertyName);
  }

  return (
    <div className="section-container">
      <div className="flex-col-12">
        <h6>Inspección</h6>

        <Inspeccion
          editable={editable}
          llantas={entity?.llantasUnidad}
          imagen={imagenUnidad}
          className="unidad"
          name="llantasUnidad"
          errors={errors}
          onChange={actualizarLlanta}
        />
      </div>

      <br />

      {entity?.conCaja === true && (
        <div className="flex-col-12 ope-daños">
          <h6>Remolque</h6>

          <Inspeccion
            editable={editable}
            llantas={entity?.llantasRemolque}
            validationDisabled={
              entity?.esExterno &&
              entity?.tipo !== constantes.tipoControlPatio.salida
            }
            imagen={imagenCaja}
            name="llantasRemolque"
            className="remolque"
            errors={errors}
            onChange={actualizarLlanta}
          />
        </div>
      )}
    </div>
  );
};

const Inspeccion = ({
  llantas,
  imagen,
  onChange,
  className,
  name,
  errors,
  validationDisabled = false,
  editable,
}) => {
  const listaLlantas = Array.isArray(llantas) ? llantas : [];

  const llantasOrdenadas = _.sortBy(
    listaLlantas,
    (llanta) => orden[llanta.posicion] ?? llanta.posicion,
  );

  function obtenerIndiceReal(posicion) {
    return listaLlantas.findIndex((llanta) => llanta.posicion === posicion);
  }

  function obtenerError(posicion) {
    const indiceReal = obtenerIndiceReal(posicion);

    if (indiceReal < 0) {
      return undefined;
    }

    return errors?.[`${name}[${indiceReal}]`];
  }

  function getItemClass() {
    return "";
  }

  function getItemClassMarca() {
    return "";
  }

  function getItemClassTipoLlanta(item) {
    if (item.llantaDanada !== true) {
      return "ope-llanta-ok";
    }

    return item.tipoLlantaDanada ? "ope-llanta-ok" : "ope-llanta-error";
  }

  function changeValueHandler(value, index, collectionName) {
    const posicion = llantasOrdenadas[index].posicion;

    const newIndex = obtenerIndiceReal(posicion);

    if (newIndex < 0) {
      return;
    }

    onChange(value, newIndex, collectionName);
  }

  function changeCautin(value, index, collectionName) {
    const posicion = llantasOrdenadas[index].posicion;

    const newIndex = obtenerIndiceReal(posicion);

    if (newIndex < 0) {
      return;
    }

    onChange(value, newIndex, collectionName, "estadoCautin");
  }

  function changeLlantaDanada(value, index, collectionName) {
    const posicion = llantasOrdenadas[index].posicion;

    const newIndex = obtenerIndiceReal(posicion);

    if (newIndex < 0) {
      return;
    }

    onChange(value, newIndex, collectionName, "estadoLlantaDanada");
  }

  function changeTipoLlantaDanada(value, index, collectionName) {
    const posicion = llantasOrdenadas[index].posicion;

    const newIndex = obtenerIndiceReal(posicion);

    if (newIndex < 0) {
      return;
    }

    onChange(value, newIndex, collectionName, "tipoLlantaDanada");
  }

  return (
    <div
className={`ope-contenedor-llanta ope-llantas-center ${className ?? ""}`}
    >
      <div className="ope-contenedor-imagen">
        {imagen?.srcLlanta && (
          <img
            className="ope-imagen-llantas"
            src={imagen.srcLlanta}
            alt="Distribución de llantas"
          />
        )}
      </div>

      {llantasOrdenadas.map((item, index) => {
        const tieneCautin =
          item.revisarCautin === true && item.sinCautinSeleccionado !== true;

        const sinCautin = item.sinCautinSeleccionado === true;

        const error = obtenerError(item.posicion);

        return (
          <React.Fragment key={item.posicion}>
            <span>{item.posicion}</span>

            <div className="ope-contenedor-opcionesllanta">
              <div className="fila-flex">
                <div className="flex-text">
                  <FieldTextBox
                    name="idCautin"
                    width="100%"
                    value={item.idCautin ?? ""}
                    disabled={!editable || sinCautin}
                    className={getItemClass(item)}
                    error={error}
                    onChange={(value) => changeValueHandler(value, index, name)}
                  />
                </div>

                <div className="flex-check">
                  <div
                    className="flex-check"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                    }}
                  >
                    <FieldCheckBox
                      name="cautinSi"
                      label="Cautín Sí"
                      value={tieneCautin}
                      disabled={!editable}
                      onChange={(event) => {
                        const checked = event?.target?.checked ?? event;

                        if (checked) {
                          changeCautin(true, index, name);
                        }
                      }}
                    />

                    <FieldCheckBox
                      name="cautinNo"
                      label="Cautín No"
                      value={sinCautin}
                      disabled={!editable}
                      onChange={(event) => {
                        const checked = event?.target?.checked ?? event;

                        if (checked) {
                          changeCautin(false, index, name);
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="flex-check">
                  <FieldCheckBox
                    name="llantaDanada"
                    label="Llanta Dañada"
                    value={item.llantaDanada === true}
                    disabled={!editable}
                    onChange={(event) =>
                      changeLlantaDanada(
                        event?.target?.checked ?? event,
                        index,
                        name,
                      )
                    }
                  />
                </div>

                <div className="flex-dropdown-danada">
                  <FieldDropDown
                    width="100%"
                    name="tipoLlantaDanada"
                    source="marcasLlantaDanadas"
                    filter
                    required={item.llantaDanada === true}
                    className={getItemClassTipoLlanta(item)}
                    error={error}
                    value={item.tipoLlantaDanada ?? null}
                    disabled={!editable || item.llantaDanada !== true}
                    onChange={(value) =>
                      changeTipoLlantaDanada(value, index, name)
                    }
                  />
                </div>
              </div>

              <div className="fila-marca">
                <div className="fila-marca-control">
                  {item.id === 0 || editable ? (
                    <FieldDropDown
                      width="100%"
                      name="marcaLlanta"
                      source="marcasLlanta"
                      filter
                      className={getItemClassMarca(item)}
                      error={error}
                      value={item.marcaLlanta ?? null}
                      disabled={!editable}
                      onChange={(value) =>
                        changeValueHandler(value, index, name)
                      }
                    />
                  ) : (
                    <FieldTextBox
                      width="100%"
                      className={getItemClassMarca(item)}
                      error={error}
                      value={item.marcaLlanta?.nombre ?? "Sin Selección"}
                      disabled
                    />
                  )}
                </div>

                <label>Marca</label>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default InspeccionLlanta;
